"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bonorva": {
    "56a19f6f": [{
      "hkey": "736e8407",
      "slug": "bonorva",
      "name": "Bonorva",
      "primary": true,
      "skipSearch": false
    }],
    "monte-cujaru": [{
      "hkey": "736e8407",
      "slug": "bonorva",
      "name": "Bonorva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d3e68ce": [{
      "hkey": "736e8407",
      "slug": "bonorva",
      "name": "Bonorva",
      "primary": true,
      "skipSearch": false
    }],
    "ospedaletto": [{
      "hkey": "736e8407",
      "slug": "bonorva",
      "name": "Bonorva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1d76bac": [{
      "hkey": "736e8407",
      "slug": "bonorva",
      "name": "Bonorva",
      "primary": true,
      "skipSearch": false
    }],
    "rebeccu": [{
      "hkey": "736e8407",
      "slug": "bonorva",
      "name": "Bonorva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;